/**
 * <i18n-t> 组件 —— 替代 vue-i18n 8.x 在本项目（vue@2.5.13）下不可用的 <i18n> 组件
 *
 * 用法（注意：vue@2.5.13 不支持 v-slot / # 简写，必须用旧式 slot="xxx"）：
 *   <i18n-t path="在 {linkA} 查看接待数据" tag="p">
 *       <template slot="linkA">
 *           <a href="...">{{ $t('网站H5接入分析') }}</a>
 *       </template>
 *   </i18n-t>
 *
 * 也支持直接在元素上写 slot：
 *   <i18n-t path="第一行{br}第二行" tag="span">
 *       <br slot="br" />
 *   </i18n-t>
 *
 * 行为：
 *   - 读取 $t(path) 拿当前 locale 翻译值
 *   - 按 /\{(\w+)\}/g 切分翻译值
 *   - 每个 {slotName} 替换为同名命名插槽的 vnodes
 *   - 未匹配上的占位符保留原文 "{slotName}" 字面输出（便于一眼发现漏 slot）
 *   - 默认 tag="span"
 */

const PLACEHOLDER_RE = /\{(\w+)\}/g;

export default {
    name: 'i18n-t',
    props: {
        path: {
            type: String,
            required: true,
        },
        tag: {
            type: String,
            default: 'span',
        },
    },
    render(h) {
        const translated = typeof this.$t === 'function'
            ? this.$t(this.path)
            : this.path;

        const scoped = this.$scopedSlots || {};
        const named = this.$slots || {};

        const children = [];
        let lastIndex = 0;
        let match;

        PLACEHOLDER_RE.lastIndex = 0;

        // eslint-disable-next-line no-cond-assign
        while ((match = PLACEHOLDER_RE.exec(translated)) !== null) {
            const [raw, slotName] = match;
            const start = match.index;

            if (start > lastIndex) {
                children.push(translated.slice(lastIndex, start));
            }

            let inserted = false;
            if (typeof scoped[slotName] === 'function') {
                const vnodes = scoped[slotName]({});
                if (vnodes != null) {
                    children.push(vnodes);
                    inserted = true;
                }
            }
            if (!inserted && named[slotName]) {
                children.push(named[slotName]);
                inserted = true;
            }
            if (!inserted) {
                // 未提供 slot：原文输出 "{slotName}"，避免静默丢失
                children.push(raw);
            }

            lastIndex = start + raw.length;
        }

        if (lastIndex < translated.length) {
            children.push(translated.slice(lastIndex));
        }

        return h(this.tag, children);
    },
};
